import React from 'react';
import Breadcrumbs, { BreadcrumbsItem } from '@atlaskit/breadcrumbs';

import { LevelsBreadcrumbsProperties, ParentOptionData } from './interfaces';

const getBreadcrumbText = (nestingIndex: number, levelParents: ParentOptionData[] | undefined) => {
    const parentBreadcrumbValue = levelParents && levelParents.find(parent => parent.depth === nestingIndex);

    return parentBreadcrumbValue
        ? `Level ${nestingIndex + 1}: ${parentBreadcrumbValue.value}`
        : `Level ${nestingIndex + 1}`;
};

const LevelsBreadcrumbs: React.FC<LevelsBreadcrumbsProperties> = ({ onClick, currentNestingLevel, currentLevelParents }) => (
    <>
        <Breadcrumbs>
            {[...Array(currentNestingLevel).keys()].map(level => <BreadcrumbsItem
                onClick={() => onClick(level)}
                text={getBreadcrumbText(level, currentLevelParents)}
                key={level}
            />)}
        </Breadcrumbs>
    </>
);

export default LevelsBreadcrumbs;
